/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import InfiniteScroll from 'react-infinite-scroller';
import api from 'api';
import { toast } from 'react-toastify';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { Header, SideMenu, Select, Search, Button, Dialog, Input } from 'components';
import { Container, ContentArea, Title, Div, DataArea, LoadingArea, CountArea, ModalButton } from './styles';
import { loadingColor, primary, white, secondary } from 'styles/colorProvider';
import { TiFilter } from 'react-icons/ti';
import { dataColumns } from './helper';
import PartnersData from 'utils/corporateSettings.json';
import ExportToExcel from 'components/ExportToExcel/index';

function Proposals({ history }) {
  const scrollParent = useRef();

  const [loading, setLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [proposalsList, setProposalsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [hasNextPage, setHasNextPage] = useState();
  const [open, setOpen] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [search, setSearch] = useState();
  const [selectStatus, setSelectStatus] = useState('all');
  const [exportStatus, setExportStatus] = useState();
  const [exportPartner, setExportPartner] = useState();
  const [startData, setStartdata] = useState();
  const [endData, setEndData] = useState();
  const [exportData, setExportData] = useState();
  const [touchFilter, setTouchFilter] = useState();
  const [selectedPartner, setSelectedPartner] = useState('all');

  const loadData = async () => {
    setLoading(true);
    setCurrentPage(1);
    const resp = await api({
      method: 'GET',
      url: `/splitrisk-proposals`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitrisk-authtoken'),
      },
      params: {
        search,
        startdate: startData === '' ? undefined : startData,
        enddate: endData === '' ? undefined : endData,
        status: selectStatus === 'all' ? undefined : selectStatus,
        page: 1,
        take: 30,
        partner: selectedPartner,
      },
      json: true,
    });
    setProposalsList(resp?.data?.proposals);
    setTotalCount(resp?.data?.totalCount);
    setHasNextPage(resp?.data?.hasNextPage);
    setLoading(false);
    setTouchFilter(false);
  };

  const handleLoadMore = async () => {
    if (!touchFilter) {
      const page = currentPage + 1;
      if (hasNextPage && !loadingMore) {
        setLoadingMore(true);
        const resp = await api({
          method: 'GET',
          url: `/splitrisk-proposals`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitrisk-authtoken'),
          },
          params: {
            search,
            startdate: startData === '' ? undefined : startData,
            enddate: endData === '' ? undefined : endData,
            status: selectStatus === 'all' ? undefined : selectStatus,
            page,
            take: 10,
            partner: selectedPartner,
          },
          json: true,
        });
        const data = proposalsList;
        const ndata = data.concat(resp?.data?.proposals);
        setCurrentPage(page);
        setProposalsList(ndata);
        setHasNextPage(resp?.data?.hasNextPage);
        setLoadingMore(false);
      }
    }
  };

  const handleClear = () => {
    setSelectStatus('all');
    setStartdata('');
    setEndData('');
  };

  const handleExport = async () => {
    setLoadingExport(true);

    try {
      const resp = await api({
        method: 'GET',
        url: `/reports/export-splitrisk-proposals`,
        headers: {
          Authorization: Cookies.get('splitrisk-authtoken'),
          feature: 'export-splitrisk-proposals',
        },
        params: {
          status: !exportStatus || exportStatus === 'all' ? undefined : exportStatus,
          partner: !exportPartner || exportPartner === 'all' ? undefined : exportPartner,
        },
        responseType: 'json',
      });

      setExportData(resp.data);

      setLoadingExport(false);
    } catch (error) {
      toast.error('Não foi possível exportar propostas', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      setOpenExport(false);
      setLoadingExport(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleOpenFilter = () => {
    setOpen(true);
  };

  const renderFilterDialog = () => (
    <Dialog open={open} onClose={() => setOpen(false)} width="50%" title="Filtrar proposta">
      <Select
        height="30px"
        label="Filtrar por canal"
        value={selectedPartner}
        onChange={(e) => setSelectedPartner(e.target.value)}
      >
        <option value={'all'}>Todos os canais</option>
        {PartnersData?.sort((a, b) => a.name.localeCompare(b.name))?.map((partner) => (
          <option key={partner?.id_partner} value={partner?.id_partner}>
            {partner?.name}
          </option>
        ))}
      </Select>

      <Select height="30px" label="Filtrar por status" value={selectStatus} onChange={(e) => setSelectStatus(e.target.value)}>
        <option value={'all'}>Todos os Status</option>
        <option value={'awaiting_inspection'}>Aguardando vistoria</option>
        <option value={'awaiting_vistei'}>Aguardando aprovação de fotos</option>
        <option value={'awaiting_complementar'}>Aguardando fotos complementares</option>
        <option value={'awaiting_registration'}>Aguardando cadastro</option>
        <option value={'awaiting_complementar_report'}>Aguardando aprovação das fotos complementares</option>
        <option value={'awaiting_payment'}>Aguardando pagamento</option>
        <option value={'activated'}>Ativada</option>
        <option value={'rejected'}> Rejeitada</option>
        <option value={'cancelled'}>Cancelada</option>
        <option value={'expired'}> Expirada</option>
      </Select>

      <Input
        value={startData}
        onChange={(e) => setStartdata(e.target.value)}
        widht="30%"
        label="Data inicial"
        mask="99/99/9999"
        height="30px"
      />
      <Input
        value={endData}
        onChange={(e) => setEndData(e.target.value)}
        widht="30%"
        label="Data final"
        mask="99/99/9999"
        height="30px"
      />
      <ModalButton>
        <Button
          height="35px"
          outlined
          disabled={selectStatus === 'all' && startData === '' && endData === ''}
          onClick={handleClear}
        >
          Limpar filtros
        </Button>
        <Button
          height="35px"
          onClick={() => {
            setTouchFilter(true);
            loadData();
            setOpen(false);
          }}
        >
          Aplicar alterações
        </Button>
      </ModalButton>
    </Dialog>
  );

  const renderExportDialog = () => (
    <Dialog
      open={openExport}
      onClose={() => {
        !loadingExport && setOpenExport(false);
        setExportStatus();
        setExportPartner();
        setExportData();
      }}
      width="50%"
      title="Exportar propostas"
    >
      {!exportData && (
        <>
          <Select height="30px" label="Status" value={exportStatus} onChange={(e) => setExportStatus(e.target.value)}>
            <option value={'all'}>Todos os Status</option>
            <option value={'awaiting_inspection'}>Aguardando vistoria</option>
            <option value={'awaiting_payment'}>Aguardando pagamento</option>
            <option value={'rejected'}>Proposta rejeitada</option>
            <option value={'cancelled'}>Proposta cancelada</option>
            <option value={'awaiting_registration'}>Aguardando cadastro</option>
            <option value={'awaiting_activation'}>Aguardando ativação</option>
          </Select>
          <Select height="30px" label="Parceiro" value={exportPartner} onChange={(e) => setExportPartner(e.target.value)}>
            <option value={'all'}>Todos os Parceiros</option>
            {PartnersData?.map((partner) => (
              <option key={partner?.id_partner} value={partner?.id_partner}>
                {partner?.name}
              </option>
            ))}
          </Select>
          <Button height="35px" style={{ margin: 0, marginTop: 30 }} onClick={handleExport} disabled={loadingExport}>
            {loadingExport ? <ReactLoading color={white} height={25} width={25} type="spin" /> : 'Exportar'}
          </Button>
        </>
      )}

      {exportData?.url ? (
        <>
          <p>Seu arquivo está pronto!</p>
          <p>
            {' '}
            <a href={exportData?.url} target="_blank" rel="noreferrer">
              Clique aqui para baixar
            </a>
          </p>
        </>
      ) : (
        <p>{exportData?.message}</p>
      )}
    </Dialog>
  );

  return (
    <>
      <Header />
      <Container>
        {renderFilterDialog()}
        {renderExportDialog()}
        <SideMenu />
        <ContentArea>
          <Div>
            <Title>PROPOSTAS</Title>
            <div className="containerTitle">
              <Button title="Exportar" height="30px" style={{ marginRight: -5 }} onClick={() => setOpenExport(true)}>
                <RiFileExcel2Fill size={18} />
              </Button>
              <Button title="Filtrar" height="30px" onClick={handleOpenFilter}>
                <TiFilter size={18} />
              </Button>

              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => {
                  setSearch('');
                  loadData();
                }}
                onConfirm={() => loadData()}
              />
            </div>
          </Div>
          <DataArea ref={scrollParent}>
            <InfiniteScroll
              loadMore={handleLoadMore}
              hasMore={hasNextPage}
              useWindow={false}
              getScrollParent={() => scrollParent?.current}
              initialLoad={false}
              style={{ width: '100%', display: 'flex' }}
              threshold={10}
            >
              <DataTable
                onRowClicked={(row) => history.push(`/backoffice/detalhes-da-proposta/${row?.id}`)}
                persistTableHead
                responsive
                columns={dataColumns}
                data={proposalsList}
                highlightOnHover
                pointerOnHover
                fixedHeader
                fixedHeaderScrollHeight="100%"
                progressPending={loading}
                progressComponent={
                  <LoadingArea>
                    <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                  </LoadingArea>
                }
                noDataComponent={<small style={{ marginTop: 20 }}>Nenhuma proposta encontrada</small>}
              />
            </InfiniteScroll>
          </DataArea>
          <CountArea>
            {loadingMore && <ReactLoading color={loadingColor} height={20} width={20} type="spin" />}

            {!loadingMore && !loading && (
              <p style={{ color: primary }}>
                Mostrando {proposalsList?.length} de {totalCount}
              </p>
            )}
          </CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default Proposals;
